import { PublicClientApplication, LogLevel } from "@azure/msal-browser";


const tenantId = process.env.REACT_APP_TENANT_ID || "default-tenant-id";
const clientId = process.env.REACT_APP_CLIENT_ID || "default-client-id";
const redirectUri = process.env.REACT_APP_REDIRECT_URL || "http://localhost:3000";


const rand_guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * (16 | 0),
      v = (c === 'x') ? r : (r & (0x3 | 0x8));
    return v.toString(16);
  });
};


// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
    // scopes: "openid",
    // nonce: rand_guid,
    // response_type: "id_token",
    // grant_type: "authorization_code",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true, // this was false before
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

export const loginRequest = {
  scopes: ["user.read"],
};

export default msalConfig;
